export default "__VITE_ASSET__335a6a09__"